import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
          main: '#FFFFFF',
        },
        secondary: {
          main: '#4CA3FC',
          contrastText: '#ffffff',
        },
        action: {
          main: '#EE1520',
          contrastText: '#ffffff',
        },
      },
      components: {
        MuiAppBar: {
          styleOverrides: {
            root: {
              backgroundColor: 'transparent',
              color: 'white',
            },
          },
        },
        MuiButton : {
          styleOverrides: {
            root: {

            }
          }
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              '& .MuiFormHelperText-root': {
                color: 'white',
              },
              '& .MuiInputLabel-root': {
                color: 'white',
              },
              '& .MuiOutlinedInput-input': {
                color: 'white',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'white',
                },
                '&:hover fieldset': {
                  borderColor: 'white',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'white',
                },
              },
            },
          },
        },
        MuiToggleButton: {
          styleOverrides: {
            root: {
              backgroundColor: '#181818',
              borderRadius: '30px',
              fontSize: '12px',
              minWidth: '30px',
              padding: '0px 10px',
              color: 'white',
              '&.Mui-selected': {
                backgroundColor: '#FFFFFF',
              },
              '&:hover': {
                backgroundColor: '#ffffff',
                color: '#181818',
              },
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              backgroundColor: 'transparent',
              color: 'white',
              borderRadius: '0px',
              fontSize: '12px',
              minWidth: '80px',
              padding: '0px'
            },
          },
        },
        MuiDialog: {
          styleOverrides: {
            paper: {
              backgroundColor: '#606060',
            },
          },
        },
      },
  })

  export default theme;